import { render, staticRenderFns } from "./DocumentosNonHistoricalTable.vue?vue&type=template&id=9c8f79f2&scoped=true"
import script from "./DocumentosNonHistoricalTable.vue?vue&type=script&lang=ts"
export * from "./DocumentosNonHistoricalTable.vue?vue&type=script&lang=ts"
import style0 from "./DocumentosNonHistoricalTable.vue?vue&type=style&index=0&id=9c8f79f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8f79f2",
  null
  
)

export default component.exports